import { render, staticRenderFns } from "./0022.vue?vue&type=template&id=1d98cbd7&scoped=true&lang=html&"
import script from "./0022.vue?vue&type=script&lang=js&"
export * from "./0022.vue?vue&type=script&lang=js&"
import style0 from "./0022.vue?vue&type=style&index=0&id=1d98cbd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98cbd7",
  null
  
)

export default component.exports